export const companySubtitleObject = {
  lightBg: true,
  lightText: false,
  subtitle: "会社概要",
  topLine: "COMPANY",
};

export const companyInformationObject = {
  name: "Komms合同会社",
  address: "〒1070062 東京都港区南青山2丁目2番",
  founded: "2021年10月07日",
  purpose: "インターネットビジネスの企画・開発・運営",
};
